import { render } from "./CategoryProductsTable.vue?vue&type=template&id=cdd8374c&scoped=true"
import script from "./CategoryProductsTable.vue?vue&type=script&lang=js"
export * from "./CategoryProductsTable.vue?vue&type=script&lang=js"

import "./CategoryProductsTable.vue?vue&type=style&index=0&id=cdd8374c&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdd8374c"]])

export default __exports__